import loginedApi from "../apis";
import {
  FETCH_DOCTOR_APPOINTMENT_HISTORY,
  FETCH_SELECTED_APPOINTMENT_DETAILS,
  ACCEPT_REQUEST,
  REJECT_REQUEST,
} from "./type";
import specialist from "../specialityList";
import moment from "moment";
import CryptoJS from "crypto-js";
var hashcode = CryptoJS.SHA256(
  process.env.REACT_APP_PREFIX +
    process.env.REACT_APP_TOKEN +
    process.env.REACT_APP_SECRETKEY
);

const publicIp = require("public-ip");
let IP = publicIp.v4();
const { detect } = require("detect-browser");
const browser = detect();
let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;
let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B");
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D");
} //replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`

//This function is to fetch the appointment history in Doctor Dashboard Page
export const fetchDoctorAppointmentHistory =
  (doctorId, offset) => async (dispatch) => {
    try {
      console.log("Inside fetchDoctorAppointmentHistory");
      console.log("Profile Id: ,", doctorId);
      let date = moment(new Date()).format("MMM DD YYYY HH:MM:SS ");
      const week = ["Sun", "Mon", "Tue", "Wed", "Thu", "Friday", "Saturday"];
      let day = week[moment().day()];

      const res = await loginedApi.post("getappointmenthistory", {
        token: hashcode.toString(),
        data: {
          doctorId: doctorId,
          operation: "start",
          browserTimeZone: `GMT${formatTime}`,
          offset: offset,
          // operationDate: "Mon Jun 13 2022 09:30:30 GMT+0530(Indian Standard Time)",
          operationDate: `${day} ${date} GMT+0530(Indian Standard Time)`,
        },
        requestType: 109,
      });
      console.log(
        "DOCTOR's getappointmenthistory data fetched!!!",
        res.data.data
      );
      console.log("response status: ", res.status);
      if (res.status === 200) {
        dispatch({
          type: FETCH_DOCTOR_APPOINTMENT_HISTORY,
          payload: res.data.data.appointmentHistory,
        });
        return res.data.data;
      }
    } catch (error) {
      console.log("🚀 ~ fetchDoctorAppointmentHistory ~ error:", error);
    }
  };

// dayOfAppointment: moment(new Date).format('DD-MMM-yyy'),
export const fetchSelectedAppointmentDetails =
  ({ appointmentId, userData }) =>
  async (dispatch) => {
    let resp = await loginedApi.post("getcountrycode", {
      token: hashcode.toString(),
      version: "2.0",
      data: { browserTimeZone: "GMT%2B05:30" },
      requestType: 1058,
    });
    const doctorscountrycode = resp.data.data;

    const res = await loginedApi.post("appointments", {
      requestType: "77",
      token: "C2MDVerificationToken",
      data: {
        appointmentId: appointmentId,
        userType: userData?.userType,
        browserTimeZone: `GMT${formatTime}`,
        userId: userData?.userId,
        currency: userData?.today_rate.currency,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Ipaddress: doctorscountrycode.Ipaddress,
        useragent: userAgent,
      },
    });

    console.log(res);

    if (res.status === 200) {
      dispatch({
        type: FETCH_SELECTED_APPOINTMENT_DETAILS,
        payload: res.data.data,
      });
    }
  };

//This function is to fetch the appointment history in Doctor Dashboard Page
export const fetchDoctordashboardDetails = (doctorId) => async (dispatch) => {
  console.log("Inside fetchDoctorAppointmentHistory");
  console.log("Profile Id: ,", doctorId);
  let date = moment(new Date()).format("MMM DD YYYY HH:MM:SS ");
  const week = ["Sun", "Mon", "Tue", "Wed", "Thu", "Friday", "Saturday"];
  let day = week[moment().day()];

  let resp = await loginedApi.post("getcountrycode", {
    token: hashcode.toString(),
    version: "2.0",
    data: { browserTimeZone: "GMT%2B05:30" },
    requestType: 1058,
  });
  const doctorscountrycode = resp.data.data;

  const res = await loginedApi.post("getdashboarddetails", {
    token: hashcode.toString(),
    data: {
      doctorId: doctorId,
      appointmentNavigation: "start",
      browserTimeZone: `GMT${formatTime}`,

      // operationDate: "Mon Jun 13 2022 09:30:30 GMT+0530(Indian Standard Time)",
      dayOfAppointment: moment(new Date()).format("DD-MMM-yyy"),
      todayRate: "74.45000",
      Browser: browser.name + " " + browser.version,
      appname: "C2MD Web",
      Os: platform,
      currency: doctorscountrycode.currency,
      accessCountry: doctorscountrycode.Country,
    },
    requestType: 109,
  });
  console.log("DOCTOR's getappointmenthistory data fetched!!!", res.data.data);
  console.log("response status: ", res.status);
  if (res.status === 200) {
    dispatch({
      type: FETCH_DOCTOR_APPOINTMENT_HISTORY,
      payload: res.data.data.appointmentHistory,
    });
    return res.data.data;
  }
};
